// extracted by mini-css-extract-plugin
export default {"profileSettings":"M60I","title":"-J86","divider":"jXyH"};